import { Auth, Config, Predicate, Query, WorkflowObjectState, CloudObject, User } from 'olympe';
import { v4 as uuidv4 } from 'uuid';
import { getUserPlants } from '../shared/_helpers';
import BCP from '../../common/section_bcp/DM_BCP';
import { BCP_WORKFLOW_STATES } from '../../common/section_bcp/BcpWorkflowAuthorizations';


/**
 *
 * @param {Array} update
 */
export const fetchRiskCrisis = async (stdFilters, topFilters, rowIndex) => {
    const rootUrl = Config.getParameter('risk_crisis_path');
    const proxyUrl = Config.getParameter('http_proxy_path');

    const userRole = JSON.parse(localStorage.getItem('plants'));
    const userPlants = userRole.roles['roles-details']['company-codes'].plants.map((item) => item.plantID);

    const access_token = sessionStorage.getItem("ms_auth_token");

    const body = {
        destination: rootUrl,
        token: Auth.getUserToken().nonce,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
        },
        opperation: 'POST',
        payload: {
            offset: rowIndex.toString(),
            limit: (rowIndex + 500).toString(),
            plants: userPlants,
        },
    };

    if (stdFilters) {
        if (stdFilters.zone) body.payload.zone = stdFilters.zone;
        if (stdFilters.plants) body.payload.plants = stdFilters.plants;
        if (stdFilters.market) body.payload.market = stdFilters.market;
        if (stdFilters.material) body.payload.materials = stdFilters.material;
        if (stdFilters.spendCategory1) body.payload.spendCategory1 = stdFilters.spendCategory1;
        if (stdFilters.spendCategory2) body.payload.spendCategory2 = stdFilters.spendCategory2;
        if (stdFilters.spendCategory3) body.payload.spendCategory3 = stdFilters.spendCategory3;
        if (stdFilters.specification) body.payload.specifications = stdFilters.specification;
        if (stdFilters.mainVendor) body.payload.mainVendor = stdFilters.mainVendor;
        if (stdFilters.vendorSiteNumber) body.payload.vendorSiteNumber = stdFilters.vendorSiteNumber;
        if (stdFilters.vendorSiteCity) body.payload.vendorSiteCity = stdFilters.vendorSiteCity;
        if (stdFilters.vendorSiteCountry) body.payload.vendorSiteCountry = stdFilters.vendorSiteCountry;
        if (stdFilters.financialRating) body.payload.financialRating = stdFilters.financialRating;
        if (stdFilters.reasonCode) body.payload.reasonCode = stdFilters.reasonCode;
        if (stdFilters.nns) body.payload.nns = stdFilters.nns;
        // TODO categories and materialGroup does not seem to be actuals filters for R&C
        if (stdFilters.categories) body.payload.spendCategory1 = stdFilters.categories;
        if (stdFilters.materialGroups) body.payload.materialGroup = stdFilters.materialGroups;
        if (stdFilters.psName) body.payload.psName = stdFilters.psName;
        if (stdFilters.pmName) body.payload.pmName = stdFilters.pmName;
        if (stdFilters.tastyClassification) body.payload.tastyClassification = stdFilters.tastyClassification;
    }

    if (topFilters) {
        if (topFilters.geoRiskLevels && topFilters.geoRiskLevels[0] !== '') body.payload.geoRiskLevels = topFilters.geoRiskLevels;
        if (topFilters.financialRiskLevels && topFilters.financialRiskLevels[0] !== '') body.payload.financialRiskLevels = topFilters.financialRiskLevels;
        if (topFilters.sourcingFlexibilityRiskLevels && topFilters.sourcingFlexibilityRiskLevels[0] !== '') body.payload.sourcingFlexibilityRiskLevels = topFilters.sourcingFlexibilityRiskLevels;
        if (topFilters.supplierOTIFRiskLevels && topFilters.supplierOTIFRiskLevels[0] !== '') body.payload.supplierOTIFRiskLevels = topFilters.supplierOTIFRiskLevels;
        if (topFilters.planningRiskLevels && topFilters.planningRiskLevels[0] !== '') body.payload.planningRiskLevels = topFilters.planningRiskLevels;
        if (topFilters.qualityRiskLevel && topFilters.qualityRiskLevel[0] !== '') body.payload.RISK_LEVEL = topFilters.qualityRiskLevel;

        if (topFilters.resExtremeWeatherRiskLevels && topFilters.resExtremeWeatherRiskLevels[0] !== '') body.payload.resExtremeWeatherRiskLevels = topFilters.resExtremeWeatherRiskLevels;
        if (topFilters.resGeopoliticalRiskLevels && topFilters.resGeopoliticalRiskLevels[0] !== '') body.payload.resGeopoliticalRiskLevels = topFilters.resGeopoliticalRiskLevels;
        if (topFilters.resPortCongestionRiskLevels && topFilters.resPortCongestionRiskLevels[0] !== '') body.payload.resPortCongestionRiskLevels = topFilters.resPortCongestionRiskLevels;
        if (topFilters.resOthersRiskLevels && topFilters.resOthersRiskLevels[0] !== '') body.payload.resOthersRiskLevels = topFilters.resOthersRiskLevels;
        if (topFilters.resQualityRiskLevels && topFilters.resQualityRiskLevels[0] !== '') body.payload.resQualityRiskLevels = topFilters.resQualityRiskLevels;
    }

    try {
        const request = await fetch(proxyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        if (!request.ok) {
            throw new Error(`Error ${request.status}`);
        }

        const result = await request.text();
        return result.length ? JSON.parse(result) : { error: false };
    } catch (error) {
        return {
            error: true,
            message: error.message,
        };
    }
};

// While creating a crisis, in "OWNER" field we storing user_email in DB.
// Here we are fetching user fullname using MS graph API.
export const getUserFullName = async (email, graphToken) => {
    const url = Config.getParameter('ms_graph_path') + `/users?$filter=mail eq '${email}'`;
    try {
        const result = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${graphToken}`
            },
        });
        let fullName;
        if (!result.ok) {
            return {
                error: true,
                message: `Error ${result.status}`
            };
        }

        else {
            const jsonResult = await result.json();
            const details = jsonResult.value[0];
            fullName = details && details.givenName && details.surname ? `${details.givenName} ${details.surname}` : details && details.displayName ? `${details.displayName}` : email;
        }
        return fullName;
    } catch (error) {
        return {
            error: true,
            message: error.message,
        };
    }
};


//Fetch loggedIn user group membership data
export const getUserMemberGroups = async (graphToken) => {
    const url = Config.getParameter('ms_graph_path') + `/me/memberOf?$select=id&$top=999`;
    try {
        const result = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${graphToken}`
            },
        });
        if (!result.ok) {
            return {
                error: true,
                message: `Error ${result.status}`
            };
        }

        else {
            const jsonResult = await result.json();
            return jsonResult.value;
        }
    } catch (error) {
        return {
            error: true,
            message: error.message,
        };
    }
};


// Filter crisis if User
// 1. Is the owner of a crisis
// 2. Is member/owner of the MS group associated with the crisis
// Here we are calling '/memberOf' API to get the list of groups(in which user has access to) and filtering 'allCrisisList'
// array to show only accessible crises.
export const filterCrisisForUser = async (graphToken, allCrisisList) => {
    const url = Config.getParameter('ms_graph_path') + `/me/memberOf`;
    try {
        const result = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${graphToken}`
            },
        });

        let filteredList = [];
        if (!result.ok) {
            return {
                error: true,
                message: `Error ${result.status}`
            };
        }
        else {
            const jsonResult = await result.json();

            const memberOfGroupList = jsonResult.value.filter(item => item["@odata.type"] === "#microsoft.graph.group");
            filteredList = allCrisisList.filter(crisis => memberOfGroupList.some(item => item.id === crisis.groupID));
        }
        return filteredList;
    } catch (error) {
        return {
            error: true,
            message: error.message,
        };
    }
};

export const getBulkCrisis = async (isAdmin, graphToken) => {
    const rootUrl = Config.getParameter('risk_crisis_bulk_path') + '/' + `all`;
    const proxyUrl = Config.getParameter('http_proxy_path');

    const access_token = sessionStorage.getItem("ms_auth_token");

    const body = {
        destination: rootUrl,
        token: Auth.getUserToken().nonce,
        headers: {
            'Authorization': `Bearer ${access_token}`,
        },
        opperation: 'GET',
    };

    try {
        const request = await fetch(proxyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        });

        if (!request.ok) {
            return {
                error: true,
                message: error.message,
            };
        }

        const result = await request.json();
        if (isAdmin) {
            console.log("User role is admin");
            return result;
        }
        else {
            console.log("User role is non-admin/regular");
            const loggedInUserMail = CloudObject.get(Auth.getCurrentUser()).get(User.loginProp);
            // Filter all those crises for which user is the owner(irrespective of MS group creation)
            const filteredCrisisListAsOwner = result.filter(crisis => crisis.owner === loggedInUserMail);
            const filteredResult = await filterCrisisForUser(graphToken, result);
            // Return after concating above 2 list and removing duplicates
            return filteredCrisisListAsOwner.concat(filteredResult.filter(item2 =>
                !filteredCrisisListAsOwner.some(item1 => item1.groupID === item2.groupID)
            ));
        }
    } catch (error) {
        return {
            error: true,
            message: error.message,
        };
    }
};

export const getSingleCrisis = async (crisisId, pageSize, page, rowCount) => {

    let startIndex = page * pageSize;
    if (startIndex >= rowCount) {
        startIndex = rowCount - 1;
    } else if (startIndex < 0) {
        startIndex = 0;
    }
    let endIndex = startIndex + pageSize;
    const rootUrl = Config.getParameter('risk_crisis_bulk_path') + '/' + `${crisisId}` + '/materials?limit=' + `${endIndex}` + '&offset=' + `${startIndex}`;

    const proxyUrl = Config.getParameter('http_proxy_path');

    const access_token = sessionStorage.getItem("ms_auth_token");

    const body = {
        destination: rootUrl,
        token: Auth.getUserToken().nonce,
        headers: {
            'Authorization': `Bearer ${access_token}`,
        },
        opperation: 'GET',
    };

    try {
        const request = await fetch(proxyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        });

        if (!request.ok) {
            throw new Error(`Error ${request.status}`);
        }

        return await request.json();
    } catch (error) {
        return {
            error: true,
            message: error.message,
        };
    }
};


export const GetLookupDataRc = async (
    search,
    filterType,
    lookupFilters,
    topFilters
) => {
    const rootUrl = Config.getParameter('risk_crisis_lookup_path');
    const proxyUrl = Config.getParameter('http_proxy_path');

    const userPlants = getUserPlants().map((item) => item.plantID);

    const access_token = sessionStorage.getItem("ms_auth_token");

    const body = {
        destination: rootUrl,
        token: Auth.getUserToken().nonce,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
        },
        opperation: 'POST',
        payload: {
            entity: filterType === 'plants' ? 'plant' : filterType,
            searchValue: search,
            zone: (lookupFilters.zone && filterType !== 'zone') ? lookupFilters.zone : [],
            market: (lookupFilters.market && filterType !== 'market') ? lookupFilters.market : [],
            plants: (lookupFilters.plants && lookupFilters.plants.length > 0 && filterType !== 'plants') ? lookupFilters.plants : userPlants,
            materials: (lookupFilters.material && filterType !== 'material') ? lookupFilters.material : [],
            spendCategory1: (lookupFilters.spendCategory1 && filterType !== 'spendCategory1') ? lookupFilters.spendCategory1 : [],
            spendCategory2: (lookupFilters.spendCategory2 && filterType !== 'spendCategory2') ? lookupFilters.spendCategory2 : [],
            spendCategory3: (lookupFilters.spendCategory3 && filterType !== 'spendCategory3') ? lookupFilters.spendCategory3 : [],
            specifications: (lookupFilters.specification && filterType !== 'specification') ? lookupFilters.specification : [],
            mainVendor: (lookupFilters.mainVendor && filterType !== 'mainVendor') ? lookupFilters.mainVendor : [],
            vendorSiteNumber: (lookupFilters.vendorSiteNumber && filterType !== 'vendorSiteNumber') ? lookupFilters.vendorSiteNumber : [],
            tastyClassification: (lookupFilters.tastyClassification && filterType !== 'tastyClassification') ? lookupFilters.tastyClassification : [],
            vendorSiteCity: (lookupFilters.vendorSiteCity && filterType !== 'vendorSiteCity') ? lookupFilters.vendorSiteCity : [],
            vendorSiteCountry: (lookupFilters.vendorSiteCountry && filterType !== 'vendorSiteCountry') ? lookupFilters.vendorSiteCountry : [],
            financialRating: (lookupFilters.financialRating && filterType !== 'financialRating') ? lookupFilters.financialRating : [],
            reasonCode: (lookupFilters.reasonCode && filterType !== 'reasonCode') ? lookupFilters.reasonCode : [],
            geoRiskLevels: (topFilters.geoRiskLevels && topFilters.geoRiskLevels[0] !== '') ? topFilters.geoRiskLevels : [],
            financialRiskLevels: (topFilters.financialRiskLevels && topFilters.financialRiskLevels[0] !== '') ? topFilters.financialRiskLevels : [],
            sourcingFlexibilityRiskLevels: (topFilters.sourcingFlexibilityRiskLevels && topFilters.sourcingFlexibilityRiskLevels[0] !== '') ? topFilters.sourcingFlexibilityRiskLevels : [],
            supplierOTIFRiskLevels: (topFilters.supplierOTIFRiskLevels && topFilters.supplierOTIFRiskLevels[0] !== '') ? topFilters.supplierOTIFRiskLevels : [],
            planningRiskLevels: (topFilters.planningRiskLevels && topFilters.planningRiskLevels[0] !== '') ? topFilters.planningRiskLevels : [],

            resExtremeWeatherRiskLevels: (topFilters.resExtremeWeatherRiskLevels && topFilters.resExtremeWeatherRiskLevels[0] !== '') ? topFilters.resExtremeWeatherRiskLevels : [],
            resGeopoliticalRiskLevels: (topFilters.resGeopoliticalRiskLevels && topFilters.resGeopoliticalRiskLevels[0] !== '') ? topFilters.resGeopoliticalRiskLevels : [],
            resPortCongestionRiskLevels: (topFilters.resPortCongestionRiskLevels && topFilters.resPortCongestionRiskLevels[0] !== '') ? topFilters.resPortCongestionRiskLevels : [],
            resOthersRiskLevels: (topFilters.resOthersRiskLevels && topFilters.resOthersRiskLevels[0] !== '') ? topFilters.resOthersRiskLevels : [],
            resQualityRiskLevels: (topFilters.resQualityRiskLevels && topFilters.resQualityRiskLevels[0] !== '') ? topFilters.resQualityRiskLevels : [],
        },
    };

    try {
        const request = await fetch(proxyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });

        if (!request.ok) {
            throw new Error(`Error ${request.status}`);
        }
        const result = await request.json();
        return result;
    } catch (error) {
        return {
            error: true,
            message: error.message,
        };
    }
};

export const deleteCrisis = async (selection) => {
    const rootUrl = Config.getParameter('risk_crisis_delete_path');
    const proxyUrl = Config.getParameter('http_proxy_path');

    const access_token = sessionStorage.getItem("ms_auth_token");
    console.log("::: deleteCrisis: access_token ::::", access_token); 

    const body = prepareBody(selection, rootUrl, access_token);

    try {
        const request = await fetch(proxyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        if (!request.ok) {
            throw new Error(`Error ${request.status}`);
        }

        let result = await request.text();
        return result.length ? JSON.parse(result) : { error: false };
    } catch (error) {
        return {
            error: true,
            message: error.message,
        };
    }
};

export const updateCrisis = async (id, details) => {
    const rootUrl = Config.getParameter('risk_crisis_bulk_path') + '/' + `${id}` + '/materials';
    const proxyUrl = Config.getParameter('http_proxy_path');

    const access_token = sessionStorage.getItem("ms_auth_token");

    const body = {
        destination: rootUrl,
        token: Auth.getUserToken().nonce,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
        },
        opperation: 'PUT',
        payload: {
            crisisID: id,
            riskcrisiselement: details.riskcrisiselement,
            status: details.status,
            header: details.header,
            action: details.action,
            ongoingCrisis: details.ongoingCrisis,
            severityLevel: details.severityLevel,
            modifiedBy: {
                userId: localStorage.getItem('userName'),
                fullName: localStorage.getItem('userFullName'),
                email: localStorage.getItem('userEmail'),
            },
            lastModified: new Date().toISOString(),
        },
    };

    try {
        const request = await fetch(proxyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        if (!request.ok) {
            throw new Error(`Error ${request.status}`);
        }

        let result = await request.text();
        return result.length ? JSON.parse(result) : { error: false };
    } catch (error) {
        return {
            error: true,
            message: error.message,
        };
    }
};

const prepareBody = (selection, rootUrl, access_token) => {
    let payload = selection.map(record => {
        return {
            crisisID: record,
            modifiedBy: {
                userId: localStorage.getItem('userName'),
                fullName: localStorage.getItem('userFullName'),
                email: localStorage.getItem('userEmail'),
            },
        };
    });
    
    let body = {
        destination: rootUrl,
        token: Auth.getUserToken().nonce,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
        },
        opperation: 'DELETE',
        payload: payload
    };
    return body;
};

const mapMaterialsForAPI = (materials) => {
    return materials.map((crisis) => {
        const mainVendor = crisis.mainVendor ? crisis.mainVendor[0] : {};
        return {
            plantId: crisis.plantId ? crisis.plantId : '',
            plantDescription: crisis.plantDescription ? crisis.plantDescription : '',
            materialId: crisis.materialId ? crisis.materialId : '',
            materialDescription: crisis.materialDescription ? crisis.materialDescription : '',
            specificationCode: crisis.specificationCode ? crisis.specificationCode : '',
            specificationDescription: crisis.specificationDescription ? crisis.specificationDescription : '',
            mainVendor: mainVendor.id ? mainVendor.id : '',
            mainVendorDescription: mainVendor.description ? mainVendor.description : '',
            vendorSiteNumber: crisis.vendorSiteNumber ? crisis.vendorSiteNumber : '',
            vendorSiteDescription: crisis.vendorSiteDescription ? crisis.vendorSiteDescription : '',
            vendorSiteCountry: crisis.vendorSiteCountry ? crisis.vendorSiteCountry : '',
            reasonCode: crisis.reasonCode ? crisis.reasonCode : '',
            financialRating: crisis.financialRating ? crisis.financialRating : '',

        };
    });
};

/**
 * Endpoint used to create a crisis
 * @param {Object} crisisDetails
 * @param {Array} crisisItems
 * @return {Promise<{error: boolean, message}|any|{error: boolean}>}
 */
export const createCrisis = async (crisisDetails, crisisItems) => {
    const crisisId = uuidv4();

    const rootUrl = Config.getParameter('risk_crisis_create_path') + '/' + `${crisisId}`;
    const proxyUrl = Config.getParameter('http_proxy_path');

    const materialsArray = mapMaterialsForAPI(crisisItems);

    const access_token = sessionStorage.getItem("ms_auth_token");

    const body = {
        destination: rootUrl,
        token: Auth.getUserToken().nonce,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
        },
        opperation: 'POST',
        payload: {
            crisisID: crisisId,
            riskcrisiselement: crisisDetails.riskcrisiselement,
            status: crisisDetails.status,
            header: crisisDetails.header,
            action: crisisDetails.action,
            ongoingCrisis: crisisDetails.ongoingCrisis,
            severityLevel: crisisDetails.severityLevel,
            materials: materialsArray,
            // modified actually refers to creator and creation date here, they should be kept when updating
            modifiedBy: {
                // TODO should get the previous creator once multiple user manage crisis
                //  ---> it is badly formatted in the data returned by the API: crisisDetails.modifiedBy = "{userId: LWaegeli,fullName: Loïc Waegeli,email: loic.waegeli@olympe.io}"
                userId: localStorage.getItem('userName'),
                fullName: localStorage.getItem('userFullName'),
                email: localStorage.getItem('userEmail'),
            },
            lastModified: new Date().toISOString(),
            owner: crisisDetails.owner
        },
    };

    try {
        const request = await fetch(proxyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        if (!request.ok) {
            // return error object returned by http proxy
            return await request.json();
        }

        let result = await request.text();
        return result.length ? JSON.parse(result) : { statusCode: 1 };
    } catch (error) {
        return {
            error: true,
            statusCode: 1,
            message: error.message,
        };
    }
};

/**
 * Endpoint to add materials to a crisis
 * @param {Object} crisisDetails
 * @param {Array} materials
 * @return {Promise<(RiskCrisisAPIResponse & {Records_Inserted: number}) | HttpProxyError>}
 */
export const addCrisisMaterials = async (crisisDetails, materials) => {
    const rootUrl = Config.getParameter('risk_crisis_add_materials_path');
    const proxyUrl = Config.getParameter('http_proxy_path');

    const materialsArray = mapMaterialsForAPI(materials);

    const access_token = sessionStorage.getItem("ms_auth_token");

    const body = {
        destination: rootUrl,
        token: Auth.getUserToken().nonce,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
        },
        opperation: 'POST',
        payload: {
            crisisID: crisisDetails.crisisID,
            riskcrisiselement: crisisDetails.riskcrisiselement,
            status: crisisDetails.status,
            header: crisisDetails.header,
            action: crisisDetails.action,
            ongoingCrisis: crisisDetails.ongoingCrisis,
            severityLevel: crisisDetails.severityLevel,
            materials: materialsArray,
            modifiedBy: {
                userId: localStorage.getItem('userName'),
                fullName: localStorage.getItem('userFullName'),
                email: localStorage.getItem('userEmail'),
            },
            lastModified: crisisDetails.lastModified,
            owner: crisisDetails.owner
        },
    };

    try {
        const request = await fetch(proxyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        if (!request.ok) {
            // return error object returned by http proxy
            return await request.json();
        }
        let result = await request.text();
        return result.length ? JSON.parse(result) : { statusCode: 1 };
    } catch (error) {
        return {
            statusCode: 1,
            message: error.message,
        };
    }
};

/**
 * Remove materials from a crisis
 *
 * @param {Object} crisisDetails
 * @param {Array} materials
 * @return {Promise<RiskCrisisAPIResponse | HttpProxyError>}
 */
export const removeCrisisMaterials = async (crisisDetails, materials) => {
    const rootUrl = Config.getParameter('risk_crisis_count_path');
    const proxyUrl = Config.getParameter('http_proxy_path');

    const materialsArray = mapMaterialsForAPI(materials);

    const access_token = sessionStorage.getItem("ms_auth_token");

    const body = {
        destination: rootUrl,
        token: Auth.getUserToken().nonce,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
        },
        opperation: 'DELETE',
        payload: {
            crisisID: crisisDetails.crisisID,
            materials: materialsArray,
            modifiedBy: {
                userId: localStorage.getItem('userName'),
                fullName: localStorage.getItem('userFullName'),
                email: localStorage.getItem('userEmail'),
            },
            lastModified: crisisDetails.lastModified,
        },
    };

    try {
        const request = await fetch(proxyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        if (!request.ok) {
            // return error object returned by http proxy
            return await request.json();
        }
        let result = await request.text();
        return result.length ? JSON.parse(result) : { statusCode: 1 };
    } catch (error) {
        return {
            statusCode: 1,
            message: error.message,
        };
    }
};

export const getMaterialsCount = async (stdFilters, topFilters) => {
    const rootUrl = Config.getParameter('risk_crisis_count_path');
    const proxyUrl = Config.getParameter('http_proxy_path');

    const userRole = JSON.parse(localStorage.getItem('plants'));
    const userPlants = userRole.roles['roles-details']['company-codes'].plants.map((item) => item.plantID);

    const access_token = sessionStorage.getItem("ms_auth_token");

    const body = {
        destination: rootUrl,
        token: Auth.getUserToken().nonce,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
        },
        opperation: 'POST',
        payload: {}
    };

    if (stdFilters) {
        if (stdFilters.zone) body.payload.zones = stdFilters.zone;
        if (stdFilters.plants) body.payload.plants = stdFilters.plants;
        if (stdFilters.material) body.payload.materials = stdFilters.material;
        if (stdFilters.spendCategory1) body.payload.spendCatL1s = stdFilters.spendCategory1;
        if (stdFilters.spendCategory2) body.payload.spendCatL2s = stdFilters.spendCategory2;
        if (stdFilters.spendCategory3) body.payload.spendCatL3s = stdFilters.spendCategory3;
        if (stdFilters.specification) body.payload.specifications = stdFilters.specification;
        if (stdFilters.mainVendor) body.payload.mainVendors = stdFilters.mainVendor;
        if (stdFilters.vendorSiteNumber) body.payload.vendorSiteNumber = stdFilters.vendorSiteNumber;
        if (stdFilters.vendorSiteCity) body.payload.vendorSiteCity = stdFilters.vendorSiteCity;
        if (stdFilters.vendorSiteCountry) body.payload.vendorSiteCountry = stdFilters.vendorSiteCountry;
        if (stdFilters.financialRating) body.payload.financialRatings = stdFilters.financialRating;
        if (stdFilters.reasonCode) body.payload.bcpStatuses = stdFilters.reasonCode;
        // TODO categories and materialGroup does not seem to be actuals filters for R&C
        if (stdFilters.categories) body.payload.spendCategory1 = stdFilters.categories;
        if (stdFilters.materialGroups) body.payload.materialGroup = stdFilters.materialGroups;
    }

    if (topFilters) {
        if (topFilters.geoRiskLevels && topFilters.geoRiskLevels[0] !== '') body.payload.geoRisks = topFilters.geoRiskLevels;
        if (topFilters.financialRiskLevels && topFilters.financialRiskLevels[0] !== '') body.payload.financialRisks = topFilters.financialRiskLevels;
        if (topFilters.sourcingFlexibilityRiskLevels && topFilters.sourcingFlexibilityRiskLevels[0] !== '') body.payload.sourcingFlexibilityRisks = topFilters.sourcingFlexibilityRiskLevels;
        if (topFilters.supplierOTIFRiskLevels && topFilters.supplierOTIFRiskLevels[0] !== '') body.payload.supplierOTIFRisks = topFilters.supplierOTIFRiskLevels;
        if (topFilters.planningRiskLevels && topFilters.planningRiskLevels[0] !== '') body.payload.planningRisks = topFilters.planningRiskLevels;

        if (topFilters.resExtremeWeatherRiskLevels && topFilters.resExtremeWeatherRiskLevels[0] !== '') body.payload.resExtremeWeatherRiskLevels = topFilters.resExtremeWeatherRiskLevels;
        if (topFilters.resGeopoliticalRiskLevels && topFilters.resGeopoliticalRiskLevels[0] !== '') body.payload.resGeopoliticalRiskLevels = topFilters.resGeopoliticalRiskLevels;
        if (topFilters.resPortCongestionRiskLevels && topFilters.resPortCongestionRiskLevels[0] !== '') body.payload.resPortCongestionRiskLevels = topFilters.resPortCongestionRiskLevels;
        if (topFilters.resOthersRiskLevels && topFilters.resOthersRiskLevels[0] !== '') body.payload.resOthersRiskLevels = topFilters.resOthersRiskLevels;
        if (topFilters.resQualityRiskLevels && topFilters.resQualityRiskLevels[0] !== '') body.payload.resQualityRiskLevels = topFilters.resQualityRiskLevels;
    }


    if (!stdFilters.plants) {
        body.payload.plants = userPlants;
    }

    try {
        const request = await fetch(proxyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        if (!request.ok) {
            throw new Error(`Error ${request.status}`);
        }
        let result = await request.text();
        return result.length ? JSON.parse(result) : { error: false };
    } catch (error) {
        return {
            error: true,
            message: error.message,
        };
    }
};

export const createBulkCrisis = async (crisisDetails, stdFilters, topFilters) => {
    const rootUrl = Config.getParameter('risk_crisis_create_path');
    const proxyUrl = Config.getParameter('http_proxy_path');

    const userRole = JSON.parse(localStorage.getItem('plants'));
    const userPlants = userRole.roles['roles-details']['company-codes'].plants.map((item) => item.plantID);

    const access_token = sessionStorage.getItem("ms_auth_token");

    const body = {
        destination: rootUrl,
        token: Auth.getUserToken().nonce,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
        },
        opperation: 'POST',
        payload: {
            crisisID: uuidv4(),
            riskcrisiselement: crisisDetails.riskcrisiselement,
            status: crisisDetails.status,
            header: crisisDetails.header,
            action: crisisDetails.action,
            ongoingCrisis: crisisDetails.ongoingCrisis,
            severityLevel: crisisDetails.severityLevel,
            modifiedBy: {
                userId: localStorage.getItem('userName'),
                fullName: localStorage.getItem('userFullName'),
                email: localStorage.getItem('userEmail'),
            },
            lastModified: new Date().toISOString(),
            owner: crisisDetails.owner
        },
    };

    if (stdFilters) {
        if (stdFilters.zone) body.payload.zones = stdFilters.zone;
        if (stdFilters.plants) body.payload.plants = stdFilters.plants;
        if (stdFilters.material) body.payload.materials = stdFilters.material;
        if (stdFilters.spendCategory1) body.payload.spendCatL1s = stdFilters.spendCategory1;
        if (stdFilters.spendCategory2) body.payload.spendCatL2s = stdFilters.spendCategory2;
        if (stdFilters.spendCategory3) body.payload.spendCatL3s = stdFilters.spendCategory3;
        if (stdFilters.specification) body.payload.specifications = stdFilters.specification;
        if (stdFilters.mainVendor) body.payload.mainVendors = stdFilters.mainVendor;
        if (stdFilters.vendorSiteNumber) body.payload.vendorSiteNumbers = stdFilters.vendorSiteNumber;
        if (stdFilters.vendorSiteCity) body.payload.vendorSiteCities = stdFilters.vendorSiteCity;
        if (stdFilters.vendorSiteCountry) body.payload.vendorSiteCountries = stdFilters.vendorSiteCountry;
        if (stdFilters.financialRating) body.payload.financialRatings = stdFilters.financialRating;
        if (stdFilters.reasonCode) body.payload.bcpStatuses = stdFilters.reasonCode;
        if (stdFilters.categories) body.payload.spendCategory1 = stdFilters.categories;
        if (stdFilters.materialGroups) body.payload.materialGroup = stdFilters.materialGroups;
    }
    if (topFilters) {
        if (topFilters.geoRiskLevels && topFilters.geoRiskLevels[0] !== '') body.payload.geoRisks = topFilters.geoRiskLevels;
        if (topFilters.financialRiskLevels && topFilters.financialRiskLevels[0] !== '') body.payload.financialRisks = topFilters.financialRiskLevels;
        if (topFilters.sourcingFlexibilityRiskLevels && topFilters.sourcingFlexibilityRiskLevels[0] !== '') body.payload.sourcingFlexibilityRisks = topFilters.sourcingFlexibilityRiskLevels;
        if (topFilters.supplierOTIFRiskLevels && topFilters.supplierOTIFRiskLevels[0] !== '') body.payload.supplierOTIFRisks = topFilters.supplierOTIFRiskLevels;
        if (topFilters.planningRiskLevels && topFilters.planningRiskLevels[0] !== '') body.payload.planningRisks = topFilters.planningRiskLevels;

        if (topFilters.resExtremeWeatherRiskLevels && topFilters.resExtremeWeatherRiskLevels[0] !== '') body.payload.resExtremeWeatherRiskLevels = topFilters.resExtremeWeatherRiskLevels;
        if (topFilters.resGeopoliticalRiskLevels && topFilters.resGeopoliticalRiskLevels[0] !== '') body.payload.resGeopoliticalRiskLevels = topFilters.resGeopoliticalRiskLevels;
        if (topFilters.resPortCongestionRiskLevels && topFilters.resPortCongestionRiskLevels[0] !== '') body.payload.resPortCongestionRiskLevels = topFilters.resPortCongestionRiskLevels;
        if (topFilters.resOthersRiskLevels && topFilters.resOthersRiskLevels[0] !== '') body.payload.resOthersRiskLevels = topFilters.resOthersRiskLevels;
        if (topFilters.resQualityRiskLevels && topFilters.resQualityRiskLevels[0] !== '') body.payload.resQualityRiskLevels = topFilters.resQualityRiskLevels;
    }

    if (!stdFilters.plants) {
        body.payload.plants = userPlants;
    }

    try {
        const request = await fetch(proxyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        if (!request.ok) {
            throw new Error(`Error ${request.status}`);
        }

        let result = await request.text();
        return result.length ? JSON.parse(result) : { error: false };
    } catch (error) {
        return {
            error: true,
            message: error.message,
        };
    }
};
/**
 * @param {!Array<!Object>} materials
 * @param {!BrickContext} $
 * @return {Promise<BCP[]>}
 */
export const getTerminatedRequests = async (materials, $) => {
    // safeguards for empty list of materials
    if (!materials || materials?.length <= 0) {
        return Promise.reject('no material provided to fetch terminated requests');
    }
    // get any BCP request matching at least one (plant, material) ids combination
    const plantMaterialPredicates = materials.map((material) => Predicate.and(
        Predicate.equals(BCP.plantIdProp, material.plantId),
        Predicate.equals(BCP.materialIdProp, material.materialId)
    ));
    const workflowPredicate = Predicate.or(
        Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.COMPLETED),
        Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.REJECTED)
    );
    // get  BCP request matching a combination, if they are in a terminating state
    const allMaterialsPredicate = Predicate.or(...plantMaterialPredicates);
    return (await Query.instancesOf(BCP).andReturn().filter(allMaterialsPredicate)
        .follow(WorkflowObjectState.currentObjectRel.getInverse()).filter(workflowPredicate).andReturn()
        .execute()).toArray().map(([bcp]) => bcp);
};

/**
 *
 * @param {!Object} materialObject
 * @param {!BrickContext} $
 * @return {Promise<boolean>}
 */
export const isBCPTerminated = async (materialObject, $) => {
    const bcpRequest = (await getTerminatedRequests([materialObject], $))?.[0];
    return Boolean(bcpRequest) && (bcpRequest.get(BCP.plantIdProp) === materialObject.plantId && bcpRequest.get(BCP.materialIdProp) === materialObject.materialId);
}
/**
 * The error object returned by the http proxy, as defined by Fastify
 * Also used if any other error arises when calling the proxy, parsing the response, ...
 *
 * @typedef {Object} HttpProxyError
 * @property {number} statusCode        the HTTP status code
 * @property {string=} error            the HTTP error message
 * @property {string} message           the user error message
 */

/**
 * The response object returned by the Nestle API
 *
 * @typedef {Object} RiskCrisisAPIResponse
 * @property {string} status                'OK' if successful
 * @property {string} message               'Success' if successful
 * @property {string} correlationId         some unique id, value not used
 * @property {string} referenceId           some unique id, value not used
 */
